import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { IConfirmationDialog } from "../../interfaces";

export const DeleteMaterialDialog: React.FC<IConfirmationDialog> = ({
    open,
    handleClose,
    ...props
}: IConfirmationDialog) => {

    return <Dialog
        open={open}
        onClose={handleClose}
    >
        <DialogTitle>Remove Material</DialogTitle>

        <DialogContent>
            Are you sure you want to remove this material from the storage request?
        </DialogContent>
        <DialogActions>
            <Button color="primary" onClick={() => handleClose(false)}>Cancel</Button>
            <Button color="error" onClick={() => handleClose(true)}>Remove</Button>
        </DialogActions>
    </Dialog>
}